import {Option, option} from "ts-option";
import {RootState} from "../reducer/root/RootState";
import Lead from "../../model/lead/Lead";
import Job from "../../model/job/Job";
import DictionaryItem from "../../model/dictionary/DictionaryItem";

/**
 * Gets job.
 * @param jobIdOrRefNumber
 * @param {RootState} state State of the redux.
 * @returns {Option<Lead>} Lead.
 */
export function getJobByIdOrRefNumber(jobIdOrRefNumber: string, state: RootState): Option<Job> {
	const job = state.job.jobsMap[jobIdOrRefNumber];
	return option(job);
}

/**
 * Returns true if all data needed to display job are in redux store.
 * @param {RootState} state State of the redux.
 * @returns {boolean} true if can display lead, false otherwise.
 */
export function canDisplayJob(state: RootState) {
	const merchants: Option<DictionaryItem[]> = state.merchant.merchants;
	return merchants.isDefined
}